import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Button, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { getPostData, AddUpdate } from "../../../ApiMethods/ApiMethods";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import swal from "sweetalert";
import profile from "../../../images/adminimg.jpg";

const AtrologerProfilePhoto = () => {
    const customerID = Number(sessionStorage.getItem("ID"));

    const [list, setList] = useState([]);
    const [singleList, setSingleList] = useState([]);
    const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
    const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [loading, setLoading] = useState(false);
    const [mobileNumber, setMobileNumber] = useState("");
    const [name, setName] = useState("");
    const [editModal, setEditModal] = useState(false);
    const [astroProfileId, setAstroProfileId] = useState(null);

    useEffect(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formattedToday = `${yyyy}-${mm}-${dd}`;
        setStartTime(formattedToday);
        setEndTime(formattedToday);
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const postData = {
                AstrologerID: "",
                RegMobileNo: mobileNumber || "",
                DisplayName: name || "",
                CreatedDtTmFrom: startTime,
                CreatedDtTmTo: endTime,
                IsCancel: 0,
                IsVerified:0
            };
            const res = await getPostData("AstrologerProfileHistory/GetData_ProfileHistory", postData);
            setList(Array.isArray(res) ? res : []);
        } catch (err) {
            console.error(err);
            setList([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        fetchData();
    };

    const handleShow = async (row) => {
        try {
            setLoading(true);
            const res = await getPostData("AstrologerProfileHistory/GetSingleData_ProfileHistory", { AstroProfileID: row?.AstroProfileID || row?.AstroProfileId || row?.ID });
            setSingleList(Array.isArray(res) ? res : []);
            setAstroProfileId(row?.AstroProfileID || row?.AstroProfileId || row?.ID);
            setEditModal(true);
        } catch (err) {
            console.error(err);
            swal("Oops", "Unable to fetch details", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (item, newVerify, newStatus = null, isCancel = 0) => {
        try {
            const postData = {
                IsVerified: newVerify ? 1 : 0,
                Status: newStatus !== null ? newStatus : item?.Status || 0,
                ModifiedByUser: customerID,
                AstroProfileID: item?.AstroProfileID || item?.AstroProfileId || item?.ID,
                IsCancel: isCancel,
            };
            await AddUpdate("AstrologerProfileHistory/Update_ProfileHistory", postData);
            swal("Good job!", "Successfully Updated", "success");
           
            if (astroProfileId) await handleShow({ AstroProfileID: astroProfileId });
           
            fetchData();
        } catch (err) {
            console.error(err);
            swal("Oops", "Update failed", "error");
        }
    };

    const columns = [
        { name: "Astrologer Name", selector: (r) => r.AstroName, sortable: true },
        { name: "Mobile No.", selector: (r) => r.RegMobileNo, sortable: true },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Dropdown style={{cursor:"pointer"}}>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">...</Dropdown.Toggle>
                        <Dropdown.Menu alignRight className="dropdown-menu-right">
                            <Dropdown.Item style={{color:"black"}} onClick={() => handleShow(row)}>Show Profile Photos</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    return (
        <div>
            <div className="form-group main_card">
                <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Profile Photo History</h2>
                <div className="row mt-3 ">
                    <div className="col-3">
                        <div className="form-group">
                            <label className="form-label">Start Time</label>
                            <input type="date" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-3">
                        <label className="form-label">End Time</label>
                        <input type="date" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-3">
                        <label className="form-label">Mobile Number</label>
                        <input type="text" value={mobileNumber} placeholder="Enter mobile number" onChange={(e) => setMobileNumber(e.target.value)} />
                    </div>
                    <div className="col-3">
                        <label className="form-label">Name</label>
                        <input type="text" value={name} placeholder="Enter name" onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="col-3 mt-1">
                        <button className="btn btn-primary mt-3" style={{ width: "90px" }} onClick={handleSearch}>Search</button>
                    </div>
                </div>
            </div>

            <div className="row main_card pt-0">
                <div className="col-xl-12">
                    <div className="p-0">
                        <div className="col-12 mt-2">
                            {loading ? (
                                <Loader />
                            ) : (
                                <DataTable dense data={list} columns={columns} selectableRowsHighlight pagination persistTableHead noDataComponent={"There are no data to display"} customStyles={customStyles} />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={editModal} onHide={() => setEditModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="w-100 text-center">Profile Photos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ height: "450px", overflowY: "scroll" }}>
                        {singleList?.length > 0 ? (
                            singleList.map((item) => (
                                <div key={item.AstroProfileID} style={{ marginBottom: 20 }}>
                                    <img src={item.AvatarUrl ? `https://${item.AvatarUrl}` : profile} alt="Profile" style={{ maxWidth: 200 }} onError={(e) => (e.target.src = profile)} />
                                    <div style={{ display: "flex", gap: 12, alignItems: "center", marginTop: 6 }}>
                                        <div style={{color:"black",fontWeight:"bold"}}>{item.IsVerified ? "Verified" : "Unverified"}</div>
                                        <button className="btn btn-sm btn-primary" onClick={() => handleUpdate(item, !item.IsVerified)}> Verify</button>
                                        <button className="btn btn-sm btn-danger" onClick={() => handleUpdate(item, item.IsVerified, item.Status, 1)}>Cancel Verify</button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ textAlign: "center" }}>NO data Available</div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AtrologerProfilePhoto;